import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { DocumentsProvider } from '@shared/docs/provider';
import { ApplicationStateProvider } from '@shared/providers/application-state';
import * as history from '@shared/router/location';
import RouterStateProvider from '@shared/router/state';
import '@shared/styles/global.css';
import '@shared/styles/reset.css';
import Bootstrap from '@shared/views/bootstrap';

import '@playbook/config';

import {
	components as documentComponents,
	config as documentConfig,
} from '@portal/config/markdoc';
import routes from '@portal/config/routes';
// The module namespace, not its default export: the manifest is self-accepting,
// so a markdown edit swaps its exports in place — see @shared/docs/provider.
import * as documents from '@portal/pkg/docs/manifest';
import { SessionProvider } from '@portal/pkg/session';
import { storage } from '@portal/pkg/storage/local';

history.init();

const mountNode = document.getElementById('root')!;

const applicationNode = (
	<StrictMode>
		<RouterStateProvider>
			<ApplicationStateProvider storage={storage}>
				<DocumentsProvider
					manifest={documents}
					config={documentConfig}
					components={documentComponents}>
					{/*
					 *	Innermost, and deliberately not suspending: there is no
					 *	Suspense boundary above Bootstrap — it puts its own
					 *	inside — so the session reports `loading` through a
					 *	field rather than by suspending.
					 */}
					<SessionProvider>
						<Bootstrap routes={routes} />
					</SessionProvider>
				</DocumentsProvider>
			</ApplicationStateProvider>
		</RouterStateProvider>
	</StrictMode>
);

if (import.meta.hot) {
	const root = (import.meta.hot.data.root ??= createRoot(mountNode));

	root.render(applicationNode);
} else {
	createRoot(mountNode).render(applicationNode);
}
